import React from 'react';
import {Link} from 'react-router-dom';
import {useLocation} from 'react-router-dom';
import {BsBookHalf, BsHouse, BsPencil} from 'react-icons/bs';
import {FaMailBulk, FaHome, FaFlagCheckered} from 'react-icons/fa'
import formatField from '../../utilis/formatFields';
import capitalizeFieldHeader from '../../utilis/capitalizeFieldHeader';
import BDeleteButton from '../buttons/BDeleteButton';
import BLoadingIndicator from '../indicators/BLoadingIndicator';
import BBlockButton from '../buttons/BBlockButton';
import BActivateButton from '../buttons/BActivateButton';
import translateFieldHeader from '../../utilis/translateFieldHeader';

const BDetailsPage = ({
  data,
  handleDelete,
  handleActivate,
  handleDeactivate,
  handleBlock,
  handleUnblock,
  isBlocked,
  isUser,
  canMessages,
  isBroker,
}) => {
  const location = useLocation();

  return (
    <>
      {data ? (
        <div className="bg-white rounded shadow-md flex flex-col border-gray-400 py-2 px-3 mt-6 m-6">
          {Object.keys(data).map((k) => (
            <div className="px-2 py-2 border-b-2 border-gray-200 flex" key={k}>
              <div className="font-bold w-1/6">{translateFieldHeader(capitalizeFieldHeader(k))}</div>
              <div className='w-5/6'>{formatField(data[k], true)}</div>
            </div>
          ))}
          <div className="px-2 py-2 border-b-2 border-gray-200 flex">
            <div className="font-bold w-1/6">Aktionen</div>
            <div className="flex items-center">
              {!isUser && (
                <Link
                  className="bg-blue-600 py-1 px-3 rounded-md shadow-md cursor-pointer text-white flex items-center hover:bg-blue-500 transition-all focus:shadow-outline focus:outline-none mr-4"
                  to={`${location.pathname}/edit`}
                >
                  <BsPencil className="text-md mr-2" />
                  Bearbeiten
                </Link>
              )}
              <BDeleteButton onDelete={handleDelete} />
              {isBroker && data.isActive && (
                <BActivateButton onActivate={handleDeactivate} btnText="Deaktivieren" />
              )}
              {isBroker && !data.isActive && (
                <BActivateButton onActivate={handleActivate} btnText="Aktivieren" />
              )}
              {!isBlocked && (
                <BBlockButton onBlock={handleBlock} btnText="Blockiere" />
              )}
              {isBlocked && (
                <BBlockButton onBlock={handleUnblock} btnText="Entsperren" />
              )}
              {(isUser && canMessages) && (
                <Link
                className="bg-blue-600 py-1 px-3 rounded-md shadow-md cursor-pointer text-white flex items-center hover:bg-blue-500 transition-all focus:shadow-outline focus:outline-none mx-4"
                to={`${location.pathname}/messages`}
              >
                <FaMailBulk className="text-md mr-2" />
                Mitteilungen
              </Link>
              )}
              {isUser && data.zipCode !== null && (
                <Link
                className="bg-purple-600 py-1 px-3 rounded-md shadow-md cursor-pointer text-white flex items-center hover:bg-purple-500 transition-all focus:shadow-outline focus:outline-none mr-4"
                to={`${location.pathname}/property`}
              >
                <FaHome className="text-md mr-2" />
                Immobilien
              </Link>
              )}
              {isBroker && (
                <Link
                  className="bg-purple-600 py-1 px-3 rounded-md shadow-md cursor-pointer text-white flex items-center hover:bg-purple-500 transition-all focus:shadow-outline focus:outline-none ml-4"
                  to={`${location.pathname}/properties`}
                >
                  <BsHouse className="text-md mr-2" />
                  Immobilien
                </Link>
              )}
              {isBroker && (
                <Link
                  className="bg-green-600 py-1 px-3 rounded-md shadow-md cursor-pointer text-white flex items-center hover:bg-green-500 transition-all focus:shadow-outline focus:outline-none ml-4"
                  to={`${location.pathname}/punkte`}
                >
                  <FaFlagCheckered className="text-md mr-2" />
                  Punkte
                </Link>
              )}
              {isUser && (
                <Link
                  className="bg-green-600 py-1 px-3 rounded-md shadow-md cursor-pointer text-white flex items-center hover:bg-green-500 transition-all focus:shadow-outline focus:outline-none mr-4"
                  to={`${location.pathname}/notes`}
                >
                  <BsBookHalf className="text-md mr-2" />
                  Anmerkungen
                </Link>
              )}
            </div>
          </div>
        </div>
      ) : (
        <BLoadingIndicator />
      )}
    </>
  );
};

export default BDetailsPage;
